export default __webpack_public_path__ + "static/media/kitAlarma1Mobile.18bc2319.png";